import React from "react";
import { Route } from "react-router-dom";
import lazyWithRetry from "helpers/lazyWithRetry";

const GeneralSettingsPage = lazyWithRetry(() =>
  import("./GeneralSettingsPage")
);

export default [
  <Route
    exact
    path="/settings/general"
    key="settings-general"
    component={GeneralSettingsPage}
  />,
];
